import React from 'react';

import { MessageBox } from 'react-chat-elements';
import PropTypes from 'prop-types';

export default function TextMessage({ message }) {
  return (
    <MessageBox
      position={message.position}
      type="text"
      text={<div dangerouslySetInnerHTML={{ __html: message.text }} />}
    />
  );
}

TextMessage.propTypes = {
  message: PropTypes.object.isRequired,
};
